<template lang="pug">
	.setting-control-coordinates(ref="field" :style="{width:`${width + 2}px`, height:`${height + 3}px`}" v-on:mousedown="setPositionByClick($event)")
		.control-area(:style="{width:`${width + 2}px`, height:`${height + 3}px`}")
		.pointer(:style="{left:`${width / 2 + (width / 2) * x}px`, top:`${height / 2 + (height / 2) * y}px`}")
			.pointer-icon.fa.fa-arrows(v-on:mousedown="startDrag($event)")
</template>

<script>

	import Screen 				from './../../mixins/screen';

	export default {
		name: 'SettingControlCoordinates',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Document Press Up": function() {

					this.endDrag();

				},
				"Document Move": function(e) {

					this.dragMove(e);

				}
			}
		},
		props: ['input', 'changed', 'initialX', 'initialY', 'propertyName'],
		watch: {
			initialX(newVal) {
				this.x = newVal;
			},
			initialY(newVal) {
				this.y = newVal;
			},
			propertyName(newVal) {
				this.property = newVal;
			}
		},
		data() {

			this.width = 60;
			this.height = 60;

			this.anchorPoints = [
				[0, 0],
				[-1, 0],
				[1, 0],
				[-1, -1],
				[0, -1],
				[1, -1],
				[-1, 1],
				[0, 1],
				[1, 1]
			];

			return {
				x: 0,
				y: 0
			};

		},
		created() {
			this.x = this.initialX;
			this.y = this.initialY;
			this.property = this.propertyName || 'offset';

		},
		methods: {
			collectData() {
			},
			startDrag(e) {

				this.isDrag = true;

				this.startDragMouseX = e.clientX;
				this.startDragMouseY = e.clientY;

				this.startDragX = this.x || 0;
				this.startDragY = this.y || 0;

			},
			dragMove(e) {

				if (!this.isDrag) return;

				this.x = this.startDragX + (e.clientX - this.startDragMouseX) / (this.width / 2);
				this.y = this.startDragY + (e.clientY - this.startDragMouseY) / (this.height / 2);

				this.normalizeCoords();

				if (this.input) this.input(this.x, this.y, this.property);

			},
			endDrag() {

				if (this.isDrag) {

					this.isDrag = false;

					if (this.changed) {
						this.changed(this.x, this.y, this.property);
					}

				}

			},
			setPositionByClick(e) {

				let fieldCoords = this.$refs['field'].getBoundingClientRect();

				this.x = (e.clientX - fieldCoords.left) / (this.width / 2) - 1;
				this.y = (e.clientY - fieldCoords.top) / (this.height / 2) - 1;

				this.normalizeCoords();

				this.startDrag(e);

			},
			normalizeCoords() {

				if (this.x > 1) this.x = 1;
				if (this.x < -1) this.x = -1;
				if (this.y > 1) this.y = 1;
				if (this.y < -1) this.y = -1;

				_.each(this.anchorPoints, anchorPoint => {

					let distance = Math.sqrt(Math.pow(this.x - anchorPoint[0], 2) + Math.pow(this.y - anchorPoint[1], 2));

					if (distance < 0.1) {

						this.x = anchorPoint[0];
						this.y = anchorPoint[1];

					}

				});

			}
		}
	}
</script>

<style lang="sass">

	.setting-control-coordinates
		width: 200px
		height: 200px
		position: relative
		border: 1px solid #23282c
		background-color: #515b65
		border-radius: 0.2rem

		.control-area
			width: 200px
			height: 200px

		.pointer
			position: absolute
			width: 0
			height: 0

			.pointer-icon
				position: absolute
				left: -7px
				top: -7px
				width: 10px
				height: 10px
				border-radius: 10px
				font-size: 14px
				color: #20a8d8
				cursor: pointer


</style>
